  'use client';
  import React from 'react';
  import { motion, AnimatePresence } from "motion/react";

  // --- Reusable Segment Component ---
  // This defines a single animated arc of the crest.
  const LoaderSegment = ({ rotation, delay }: { rotation: number; delay: number }) => (
    <motion.div
      className="absolute h-full w-full"
      style={{ rotate: rotation }}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5, delay: 0.2 }}
    >
      <motion.div
        className="h-1/2 w-full overflow-hidden"
      >
        <motion.div
          className="h-full w-full rounded-full border-2 border-amber-400"
          style={{
            boxShadow: '0 0 10px #d4af37, 0 0 20px #8a2be2',
            borderColor: '#d4af37' /* Gold */
          }}
          initial={{ y: '-100%' }}
          animate={{ y: '0%' }}
          transition={{
            duration: 0.8,
            ease: 'circOut',
            delay,
            repeat: Infinity,
            repeatType: 'reverse',
            repeatDelay: 1,
          }}
        />
      </motion.div>
    </motion.div>
  );

  // --- Main Loader Component ---
  // This assembles the segments and handles visibility.
  interface PremiumLoaderProps {
    loading: boolean;
  }

  const PremiumLoader: React.FC<PremiumLoaderProps> = ({ loading }) => {
    return (
      <AnimatePresence>
        {loading && (
          <motion.div
            className="fixed inset-0 z-50 grid place-items-center bg-black/80 backdrop-blur-sm"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
          >
            <div className="relative h-20 w-20">
              <LoaderSegment rotation={45} delay={0} />
              <LoaderSegment rotation={135} delay={0.2} />
              <LoaderSegment rotation={225} delay={0.1} />
              <LoaderSegment rotation={315} delay={0.3} />
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    );
  };

  export default PremiumLoader;
